module.exports = new __parcel__URL__("faq_content_ko.ce87c524.webp").toString();